import { Flex } from '@/components/base';
import SelectDropdown from '@/components/Select/SelectDropdown';
import type { SelectOptionT } from '@/components/Select/types';
import { MainText } from '@/components/Typography/NamedTypo';
import PropertyValue, {
  PropertyValueStyle,
} from '@/components/Typography/PropertyValue';
import { UNASSIGNED_LABEL } from '@/configs/reserved-word';
import useAgentStore from '@/features/Agent/stores';

export type Props = {
  selected: string;
  useShortcut?: boolean;
  name: string;
  onSelect: (key: string) => void;
  onClear?: () => void;
};

const AgentDropdown = ({
  selected,
  useShortcut,
  name,
  onSelect,
  onClear,
}: Props) => {
  const agentMap = useAgentStore((state) => state.agentMap);

  const options: SelectOptionT[] = [
    ...Object.values(agentMap).map((agent) => ({
      value: agent.alias,
      searchName: agent.name,
    })),
  ];

  const selectedItem = options.find((option) => option.value === selected);

  return (
    <SelectDropdown
      name={name}
      width="300px"
      searchOptions={{
        enable: true,
      }}
      data={() => ({
        list: options,
        cursor: null,
      })}
      value={selected}
      mapper={(op) => {
        const agent = agentMap[op.value];
        return (
          <Flex g="6px" a="center">
            <MainText>{agent.name}</MainText>
            <MainText dim ellipsis>
              {agent.email}
            </MainText>
          </Flex>
        );
      }}
      placeholder={UNASSIGNED_LABEL}
      customMapper={() => {
        return selectedItem ? (
          <PropertyValueStyle>{selectedItem.searchName}</PropertyValueStyle>
        ) : (
          <PropertyValue value={UNASSIGNED_LABEL} />
        );
      }}
      onSelect={(key) => onSelect(key as string)}
      shortcut={useShortcut ? 'KeyA' : ''}
      onClear={onClear}
    />
  );
};

export default AgentDropdown;
